import { Log } from '@devanjs/log';
import type { RouteRecordRaw } from 'vue-router';
import { services } from '../services';
import type { IntegrationInstallation } from '../types/integrationInstallation';

export const installRoute = async (
  installations: IntegrationInstallation<any>[],
  route:
    | RouteRecordRaw
    | Promise<RouteRecordRaw>
    | (() => RouteRecordRaw)
    | (() => Promise<RouteRecordRaw>),
) => {
  const resolvedRoute = await (route instanceof Function ? route() : route);

  Log.tag('integrations').space().lightGreen('Route').info(resolvedRoute.path);

  if (resolvedRoute.meta === undefined) {
    resolvedRoute.meta = {};
  }

  installations.forEach((installation) => {
    resolvedRoute.meta!.integration = installation.integration;
    resolvedRoute.meta!.requireProject = true;

    installation.routes.push(resolvedRoute);
  });

  if (services.router !== undefined) {
    services.router.addRoute(resolvedRoute);
  } else {
    Log.red('Integrations').info('Router not found');
  }
};
